import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function AboutPage() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = 'About Us | AllChinaBuy Spreadsheet Hub';
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <div className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-16">
          <div className="max-w-3xl mx-auto">
            <h1 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 mb-6">About AllChinaBuy Spreadsheet Hub</h1>
            <div className="prose max-w-none text-foreground-700 leading-relaxed space-y-4">
              <p>
                AllChinaBuy Spreadsheet Hub is an independent informational resource designed to help buyers research products, sellers, shipping options, and quality practices when using buying-agent platforms. Our goal is to organize useful information into clear, accessible categories so you can make more informed purchasing decisions.
              </p>
              <p>
                We are not affiliated with any buying-agent platform or marketplace. We do not sell products, process payments, or handle transactions. This website serves as an educational resource only, providing guides, comparisons, and practical information based on publicly available knowledge and industry practices.
              </p>
              <h2 className="font-heading text-2xl font-semibold text-foreground-950 mt-8 mb-4">Our Mission</h2>
              <p>
                The buying-agent ecosystem can be complex and confusing for new buyers. Our mission is to provide clear, honest, and practical information that helps you navigate the research process, understand risks, and make better-informed decisions. We focus on transparency, independent analysis, and educational value.
              </p>
              <h2 className="font-heading text-2xl font-semibold text-foreground-950 mt-8 mb-4">What We Cover</h2>
              <ul className="list-disc list-inside space-y-2 pl-1">
                <li>Product category research and discovery resources</li>
                <li>Seller evaluation guides and risk awareness</li>
                <li>Quality check (QC) practices and photo analysis</li>
                <li>Shipping methods, costs, and delivery factors</li>
                <li>Coupon and promotional offer awareness</li>
                <li>Legitimacy, safety, and scam prevention</li>
                <li>Comparison guides and buying strategies</li>
              </ul>
              <h2 className="font-heading text-2xl font-semibold text-foreground-950 mt-8 mb-4">Important Disclaimer</h2>
              <p>
                This website provides general educational information only. We do not guarantee the accuracy, completeness, or timeliness of any information. We do not endorse any platform, seller, or product. All purchasing decisions are your own responsibility. Always verify current information directly with platforms and sellers before making purchases.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}